/**
 * 内容详情 API
 *
 * 获取单条内容的完整信息 (标题、来源、段落列表等)
 */

import type { ParagraphT } from '@/utils/type';
import { contentFetcher } from '../fetcher';
import { isProd } from '@/utils/env';

/** 内容详情数据结构 */
export interface Content {
    // 标题
    title: string;
    // 来源
    publisher: string;
    // 头图 URL
    banner: string;
    // 段落列表
    contentList: ParagraphT[];
    // 分类 ID
    categoryId: string;
    // 服务 ID
    serviceId: string;
    // 图片 ID
    imageId: string;
    // 内容 ID
    contentId: string;
}

/** 静态资源路径 (生产/开发环境不同) */
const PATH = isProd
    ? '/cdo-activity/general-resources/lockscreen'
    : '/cdoActivity/general-resources/lockscreen';

/**
 * 获取内容详情
 * @param contentId - 内容 ID
 * @returns 内容详情, 失败返回 null
 */
export const fetchContent = async (
    contentId: string,
): Promise<Content | null> => {
    try {
        // 请求静态 JSON 文件
        const res = await contentFetcher.get<Content>(
            `${PATH}/${contentId}.json`,
        );

        // 校验返回数据
        if (!res.contentList?.length) {
            console.error('Invalid content:', res);
            return null;
        }

        return res;
    } catch (err) {
        console.error('Error fetching content:', err);
        return null;
    }
};
